import { useEffect, type RefObject } from "react";

export interface UseDismissOutsideParams {
  ref: RefObject<HTMLElement | null>;
  isOpen: boolean;
  onDismiss: () => void;
  extraRefs?: RefObject<HTMLElement | null>[];
}

export function useDismissOutside({
  ref,
  isOpen,
  onDismiss,
  extraRefs = [],
}: UseDismissOutsideParams): void {
  useEffect(() => {
    if (!isOpen) return;

    const handleMouseDown = (event: MouseEvent) => {
      const target = event.target as Node;
      if (ref.current?.contains(target)) return;

      for (const er of extraRefs) {
        if (er.current?.contains(target)) return;
      }

      onDismiss();
    };

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") onDismiss();
    };

    document.addEventListener("mousedown", handleMouseDown, true);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("mousedown", handleMouseDown, true);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onDismiss, ref]);
}
